/** @file:封装axios文件 */
import Qs from 'qs';
import axios from 'axios';
import {
	MessageBox,
	Loading,
} from 'element-ui';
import router from '../router/index';

const instance = axios.create({});

instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
instance.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded';

let loadingInstance;

// 添加请求拦截器
instance.interceptors.request.use(function(config) {
	// 在发送请求之前做些什么
	loadingInstance = Loading.service({text:'加载中'});
	
	config.data = Qs.stringify(config.data);
	//在请求头部添加参数
	config.headers.post['Access-Token'] = localStorage.getItem("tb_token");
	config.headers.get['Access-Token'] = localStorage.getItem("tb_token");
	
	return config;
}, function(error) {
	// 对请求错误做些什么
	return Promise.reject(error);
});

// 添加响应拦截器
instance.interceptors.response.use(function(response) {
	// 对响应数据做点什么
	if(response.data.status == 401 && response.data.message == '请先登录后再访问'){
		MessageBox.alert(response.data.message, '提示', {
				confirmButtonText: '确定',
				type: 'warning',
				showClose: false,
				callback: action => {
					console.log(action)
				localStorage.removeItem('tb_token');
				localStorage.removeItem('tb_user_name');
				router.push('/index/login');
			}
		});
	}
	// if (response.code === 0) {
	// 	MessageBox.alert(response.message, '提示', {
	// 			confirmButtonText: '确定',
	// 			type: 'warning',
	// 			showClose: false,
	// 			callback: action => {
	// 				console.log(action)
	// 			localStorage.removeItem('token');
	// 			localStorage.removeItem('user_name');
	// 			router.push('/login');
	// 		}
	// 	});
	// }
	loadingInstance.close();
	
	return Promise.resolve(response.data);
}, function(error) {
	// 对响应错误做点什么
	loadingInstance.close();
	return Promise.reject(error);
});

export default instance;
